import BaseSvgSprite from '@Shared/Ui/BaseSvgSprite';
import { cn } from '@Shared/Helpers/Utilities';
import PropTypes from 'prop-types';

const SvgSprite = ({
    testid = 'svg-sprite',
    className = null,
    prefix = 'new-icons',
    collectionName,
    iconId,
    ...rest
}) => {
    return (
        <BaseSvgSprite
            testid={testid}
            className={cn(['size-6', className])}
            collectionName={collectionName}
            iconId={iconId}
            prefix={prefix}
            {...rest}
        />
    );
};

SvgSprite.propTypes = {
    iconId: PropTypes.string.isRequired,
    collectionName: PropTypes.string.isRequired,
    testid: PropTypes.string,
    className: PropTypes.string,
    prefix: PropTypes.string,
};
export default SvgSprite;
